<template>
  <div class="upDataIDDiv">
    <div
      class="upDataID"
      v-if="successfulData"
      v-loading="loading"
      element-loading-text="上传中，请稍后..."
    >
      <h3 class="upDataIDH32">上传身份证照片</h3>
      <!-- {{files}} -->
      <div>
        <p class="upDataIDH3P2">
          1. 请确保照片的清晰完整度，仅支持jpg、png格式，小于2M；
        </p>
        <p class="upDataIDH3P2">2. 请上传彩色图像。</p>
      </div>
      <div
        :class="msgData ? 'reverse reverseErr' : 'reverse'"
        @click="isOpen(0)"
      >
        <img v-if="reverseData" :src="reverseData" alt="" class="reverseImg2" />
        <img
          v-else
          class="reverseImg2"
          src="~@/assets/images/upData/upData.png"
          alt=""
        />
        <!--        <el-upload-->
        <!--          class="upload-demo"-->
        <!--          action="/api/exam/upload/uploadFile"-->
        <!--          :show-file-list="false"-->
        <!--          :on-success="uploadSuccess"-->
        <!--          :on-error="uploadError"-->
        <!--          :on-progress="upProgress"-->
        <!--          ref="uploadTemplate"-->
        <!--        >-->
        <!--          <img v-if="reverseData" :src="reverseData" alt=""   class="reverseImg2">-->
        <!--          <img v-else class="reverseImg2" src="~@/assets/images/upData/upData.png" alt="">-->
        <!--        </el-upload>-->
        <p>点击上传身份证人像面</p>
      </div>
      <p style="font-size: 15px; color: #df3030; margin-top: 10px">
        {{ msgData }}
      </p>
      <div class="reverse" @click="isOpen(1)">
        <img
          v-if="positiveData"
          :src="positiveData"
          alt=""
          class="reverseImg2"
        />
        <img
          v-else
          class="reverseImg2"
          src="~@/assets/images/upData/upData2.png"
          alt=""
        />
        <!--        <el-upload-->
        <!--          class="upload-demo"-->
        <!--          action="/api/exam/upload/uploadFile"-->
        <!--          :show-file-list="false"-->
        <!--          :on-success="uploadSuccess2"-->
        <!--          :on-error="uploadError"-->
        <!--          :on-progress="upProgress"-->
        <!--          ref="uploadTemplate"-->
        <!--        >-->
        <!--          <img v-if="positiveData" :src="positiveData" alt="" class="reverseImg2">-->
        <!--          <img v-else class="reverseImg2" src="~@/assets/images/upData/upData2.png" alt="">-->
        <!--        </el-upload>-->
        <p>点击上传身份证国徽面</p>
      </div>
      <div style="width: 100%; height: 40px"></div>
      <button
        :class="modelType ? 'button2State' : 'button2'"
        @click="upDataImg()"
      >
        开始上传
      </button>
    </div>
    <div class="upDataID" v-else>
      <em class="successfulIcon"></em>
      <p class="successfulTitle">提交成功</p>
      <p class="successfulText">若电脑网页5秒后未跳转，请刷新页面</p>
    </div>
    <el-drawer
      :visible.sync="drawer"
      :modal="false"
      :show-close="false"
      :direction="direction"
    >
      <ul class="chooseUpdata">
        <li>
          拍照上传
          <input
            class="input"
            @change="isUpData($event)"
            type="file"
            accept="image/*"
            capture="camera"
            value=""
          />
        </li>
        <li>
          从手机相册选择<input
          class="input"
          @change="isUpData($event)"
          type="file"
          accept="image/*"
          value=""
        />
        </li>
        <li @click="drawer = false">取消</li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
import { faceServe } from "@/api/home";
import { putObject } from "@/utils/upload.js";
export default {
  name: "upDataID",
  data() {
    return {
      modelType: false,
      reverseData: "",
      positiveData: "",
      dataArr: ["", ""],
      msgData: "",
      tokenData: "",
      successfulData: true,
      loading: false,
      direction: "btt",
      drawer: false,
      typeIndex: 0,
      //photo_arr: [],
      files:''
    };
  },

  computed: {
    dateRange() {
      const { reverseData, positiveData } = this;
      return {
        reverseData,
        positiveData,
      };
    },
  },
  watch: {
    dateRange(val) {
      if (val.reverseData && val.positiveData) {
        this.modelType = true;
      }
    },
  },
  mounted() {
    this.tokenData = this.$route.query.token;
    this.classId = this.$route.query.classId;
    // this.$store.dispatch('common/getS3ClientAction')
    // 手机浏览器打开时 没有登录时设置的浏览器 成教/自考 状态
    // 这里获取地址的状态 并设置缓存
    window.localStorage.setItem('_ENTRANCETYPE',this.$route.query.entranceType);
  },
  methods: {
    isUpData(e) {
      let files = e.target.files[0];
      let size = Math.round(Number(files.size) / 1024 * 100) / 100;
      if(size > 2048){
        this.$message.warning('图片过大，请选择不超过2M的图片');
        return;
      }
      this.loading = true;
      this.drawer = false;
      this.files = files;
      putObject(files, (res) => {
        if (this.typeIndex) {
          this.positiveData = res;
        } else {
          this.reverseData = res;
        }
        this.loading = false;
      }, null, 'images', '', false);
    },
    isOpen(typeIndex) {
      this.drawer = true;
      this.typeIndex = typeIndex;
    },

    async upDataImg() {
      if (!this.modelType) return;
      this.loading = true;
      const { data } = await faceServe.recognizeCard(
        {
          id_card_phone: this.reverseData,
          id_card_behind: this.positiveData,
          class_id:this.classId
        },
        {
          token: this.tokenData,
        }
      );
      if (data.code === 200) {
        faceServe
          .postPhoto(
            {
              tag: this.$route.query.mobile,
              url: this.reverseData,
            },
            {
              token: this.tokenData,
            }
          )
          .then((item) => {
            if (item.data.code === 200) {
              this.successfulData = false;
              this.loading = false;
              return;
            }
            this.loading = false;
            this.msgData = data.message;
          });
        return;
      }
      this.loading = false;
      this.msgData = data.message;
    },
    uploadSuccess(response) {
      if (response.code === 0) {
        this.reverseData = response.data;
        this.dataArr.splice(0, 1, this.reverseData);
        this.loading = false;
      }
    },
    uploadError() {
      this.loading = false;
      this.$message.error("上传失败");
    },
    upProgress() {
      this.loading = true;
    },
    uploadSuccess2(response) {
      if (response.code === 0) {
        this.positiveData = response.data;
        this.dataArr.splice(1, 1, this.positiveData);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.upDataID {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 20px;
  text-align: center;
}
.upDataID .upDataIDH32 {
  font-size: 22px;
  color: #000;
  margin: 22px 0 10px;
}
.upDataID .upDataIDH3P2 {
  font-size: 13px;
  color: #999;
  text-align: left;
}
.upDataID .reverse {
  width: 86%;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  margin-top: 25px;
  padding-bottom: 10px;
  padding-top: 20px;
  margin-left: 7%;
}
.upDataID .reverse .reverseImg2 {
  width: 70%;
  height: 150px;
  margin-bottom: 20px;
}
.upDataID .reverse p {
  font-size: 15px;
  color: #666;
}
.upDataID .button2 {
  width: 86%;
  height: 45px;
  background-color: #b6c3fe;
  border-radius: 50px;
  border-style: none;
  font-size: 15px;
  color: #fff;
}
.upDataID .button2State {
  width: 86%;
  height: 45px;
  background-color: #3056ff;
  border-radius: 50px;
  border-style: none;
  font-size: 15px;
  color: #fff;
}

.upDataID .successfulIcon {
  width: 200px;
  height: 152px;
  background: url("~@/assets/images/upData/successful.png") no-repeat;
  background-size: 100% 100%;
  margin: 80px 0 10px;
}
.upDataID .successfulTitle {
  font-size: 30px;
  color: #6f9bbe;
}
.upDataID .successfulText {
  font-size: 20px;
  color: #666;
  margin-top: 20px;
}

.chooseUpdata {
  width: 100%;
}

.chooseUpdata li {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #000;
  position: relative;
}

.chooseUpdata li:first-child {
  border-bottom: 1px solid #f8f8f8;
}
.chooseUpdata li:last-child {
  border-top: 5px solid #f8f8f8;
}
.chooseUpdata li .input {
  width: 100%;
  height: 60px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

/deep/ .el-upload-list__item-name {
  display: none;
}

/deep/ .el-upload-list--picture .el-upload-list__item {
  height: 185px;
}

/deep/ .el-upload-list__item-thumbnail {
  width: 120px;
  height: 120px;
}

/deep/ .el-drawer__open .el-drawer.btt {
  height: 185px !important;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

/deep/ .el-drawer__header {
  margin-bottom: 0;
  padding: 0;
}
</style>
